export default __webpack_public_path__ + "static/media/face_1_54.d0e9fc32.png";